const CompanionSettingWrapper = ({
  title,
  description,
  children,
}) => {
  return (
    <div className="flex flex-col gap-2 border border border-gray-200 dark:border-gray-700 pb-4 rounded-xl p-4">
      <b className="text-xl">{title}</b>
      <span className="text-md">{description}</span>
      {children}
    </div>
  );
};

export default CompanionSettingWrapper;
